/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Header,
  SidebarLayout,
  Icon,
  Select,
  InputLabel,
  Tooltip,
  Grid,
  Loader,
  Modal,
  Input,
  Button,
  ThemeType,
  toggleTheme,
} from '@scuf/common';

import {
  AppSessionTimeoutModal,
  NotificationHeader,
  NotificationHeaderModal,
  util,
} from '@keystone/common';
import UserDropdown from './UserDropdown';
import Routes from '../common/routes';
import {
  withCustomerSiteContext,
  withOperatorContext,
  withUserContext,
  withApplicationContext,
  withDeviceInfoContext,
  withSiteContext,
  withDeviceLogsContext,
} from '../common/HOCs';

const { Sidebar } = SidebarLayout;

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        username: null,
        password: null,
        newPassword: null,
        newPasswordConfirm: null,
      },
      isSideBarCollapsed: false,
      open: false,
      loadingSettings: false,
      collapsed: false,
      activeName: '',
      expand: [],
    };

    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleSubmenuClick = this.handleSubmenuClick.bind(this);
  }

  handleCollapse() {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  }

  handleItemClick(event, itemProps) {
    const { name } = itemProps;
    this.setState({ activeName: name });
  }

  handleSubmenuClick(event, itemProps) {
    const expand = [...this.state.expand];
    const { name } = itemProps;
    const expanderIndex = expand.findIndex((element) => element === name);
    if (expanderIndex >= 0) {
      expand.splice(expanderIndex, 1);
    } else {
      expand.push(name);
    }
    this.setState({ expand });
  }

  onUserNameChange = (userName) => {
    this.setState({ form: { ...this.state.form, userName } });
  };

  onPasswordChange = (password) => {
    this.setState({ form: { ...this.state.form, password } });
  };

  onNewPasswordChange = (newPassword) => {
    this.setState({ form: { ...this.state.form, newPassword } });
  };

  onNewPasswordConfirmChange = (newPasswordConfirm) => {
    this.setState({ form: { ...this.state.form, newPasswordConfirm } });
  };

  componentDidMount() {
    const { custSiteContext } = this.props;
    custSiteContext.init();
    this.initDisplayTheme();
  }

  initDisplayTheme = async () => {
    const { appContext } = this.props;
    if (appContext.userData && appContext.userData.response.preferences) {
      const { theme } = appContext.userData.response.preferences;
      if (theme) {
        if (theme === 'light') {
          toggleTheme(ThemeType.Light);
        }
        if (theme === 'dark') {
          toggleTheme(ThemeType.Dark);
        }
      }
    }
  };

  openUpdatePasswordModal = () => {
    const form = {
      username: null,
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
    };
    this.setState({ form });
    this.onUserNameChange(this.props.appContext.user.email);
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.setState({ open: true });
  };

  clearSelectionAfterCancelEdit = () => {
    const form = {
      username: null,
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
    };
    this.setState({ form });
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.props.appContext.setNotification(null);
    this.setState({ open: false });
  };

  isPasswordMatching = (form) => {
    if (form.newPassword === form.newPasswordConfirm) {
      return true;
    }
    return false;
  };

  toggleLoading() {
    this.setState((prevState) => ({ loadingSettings: !prevState.loadingSettings }));
  }

  render() {
    const { custSiteContext } = this.props;
    return (
      <>
        <Header
          title="Enterprise Voice"
          onMenuToggle={() => this.setState({ isSideBarCollapsed: !this.state.isSideBarCollapsed })}
        >
          <Header.Item className="ev-header-item">
            <InputLabel label="Customer:" />
          </Header.Item>
          <Header.Item className="ev-header-item">
            {this.renderUpdatePasswordModal()}
            <Select
              className="cust-site-dropdown"
              value={custSiteContext.selectedCustomer}
              options={custSiteContext.customerList}
              onChange={(value) => custSiteContext.setSelectedCustomer(value)}
              disabled={!(custSiteContext.customerList.length > 1)}
            />
          </Header.Item>

          {this.renderSiteDropdown()}

          <Header.IconItem
            icon={<Icon root="building" name="badge-help" />}
            description="Browse Help"
            href={util.getHelpURI()}
            target="_blank"
            rel="noopener noreferrer"
            className="ev-header-item"
          />
          <UserDropdown handleChangePassword={() => this.openUpdatePasswordModal()} />
        </Header>
        {this.renderUserManagementSideBarModal()}
        <AppSessionTimeoutModal />
      </>
    );
  }

  renderUserManagementSideBarModal() {
    const { collapsed, activeName, expand } = this.state;
    return (
      <SidebarLayout className="app-sidebar" noIcons collapsed={this.state.isSideBarCollapsed}>
        <SidebarLayout.Sidebar>
          <SidebarLayout.Sidebar.Submenu
            content="Admin"
            activeName={activeName}
            name="AdminExpander"
            icon="settings"
            iconRoot="global"
            onClick={this.handleSubmenuClick}
            open={expand.includes('AdminExpander')}
          >
            <SidebarLayout.Sidebar.Item
              content="Sites"
              icon="sites-pin"
              iconRoot="global"
              onClick={() => {
                this.setState({ activeLink: Routes.Sites });
                this.props.history.push(Routes.Sites);
              }}
              active={this.props.location.pathname.includes(Routes.Sites)}
            />
          </SidebarLayout.Sidebar.Submenu>
          <SidebarLayout.Sidebar.Item
            content="Users"
            icon="user-group"
            onClick={() => {
              this.setState({ activeLink: Routes.Users });
              this.props.history.push(Routes.Users);
            }}
            active={this.props.location.pathname.includes(Routes.Users)}
          />
          <SidebarLayout.Sidebar.Item
            content="Operators"
            icon="tools"
            iconRoot="global"
            onClick={() => {
              this.setState({ activeLink: Routes.Operators });
              this.props.history.push(Routes.Operators);
            }}
            active={this.props.location.pathname.includes(Routes.Operators)}
          />
          <SidebarLayout.Sidebar.Item
            content="Devices"
            icon="multiple-devices"
            iconRoot="global"
            onClick={() => {
              this.setState({ activeLink: Routes.DeviceInfo });
              this.props.history.push(Routes.DeviceInfo);
            }}
            active={this.props.location.pathname === Routes.DeviceInfo}
          />
          <SidebarLayout.Sidebar.Item
            content="Logs"
            icon="inspections"
            iconRoot="global"
            onClick={() => {
              this.setState({ activeLink: Routes.DeviceLogs });
              this.props.history.push(Routes.DeviceLogs);
            }}
            active={this.props.location.pathname === Routes.DeviceLogs}
          />

          <SidebarLayout.Sidebar.Item
            content="License Info"
            icon="document-certification"
            iconRoot="common"
            onClick={() => {
              this.setState({ activeLink: Routes.ViewLicense });
              this.props.history.push(Routes.ViewLicense);
            }}
            active={this.props.location.pathname === Routes.ViewLicense}
          />
          <SidebarLayout.Sidebar.Item
            content="Device Config"
            iconRoot="common"
            icon="smartphone"
            onClick={() => {
              this.setState({ activeLink: Routes.DeviceConfig });
              this.props.history.push(Routes.DeviceConfig);
            }}
            active={this.props.location.pathname === Routes.DeviceConfig}
          />
        </SidebarLayout.Sidebar>
        <SidebarLayout.Content>
          {this.props.appContext.notification.hasNotification ? <NotificationHeader /> : <></>}
          {this.props.children}
        </SidebarLayout.Content>
      </SidebarLayout>
    );
  }

  renderSiteDropdown() {
    const { custSiteContext } = this.props;
    // initiliaze array of pages that should not have the site dropdown rendered
    const pages = [
      Routes.Login,
      Routes.Sites,
      Routes.DeviceLogs,
      Routes.DeviceConfig,
      Routes.ViewLicense,
      Routes.DeviceInfo,
    ];

    // if page list includes the path, return nothing
    // else perform the function
    const pageName = this.props.location.pathname;
    if (pages.includes(pageName)) {
      return <></>;
    }
    return (
      <>
        <Header.Item className="ev-header-item">
          <InputLabel label="Site:" />
        </Header.Item>
        <Header.Item className="ev-header-item">
          <Select
            className="cust-site-dropdown"
            value={custSiteContext.selectedSite}
            options={custSiteContext.siteList}
            onChange={(value) => custSiteContext.setSelectedSite(value)}
            disabled={!(custSiteContext.siteList.length > 1)}
          />
        </Header.Item>
      </>
    );
  }

  renderUpdatePasswordModal() {
    return (
      <Modal
        onClose={() => this.setState({ open: false })}
        open={this.state.open}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        size="small"
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Update Password</h1>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Input
                  fluid
                  error={null}
                  type="password"
                  label="Current Password"
                  maxLength="30"
                  placeholder="Password"
                  indicator="required"
                  onChange={(data) => this.onPasswordChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={12}>
                      <InputLabel label="New Password" indicator="required" />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={10}>
                      <Input
                        fluid
                        error={null}
                        type="password"
                        maxLength="30"
                        placeholder="Password"
                        onChange={(data) => this.onNewPasswordChange(data)}
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <Tooltip
                        content="Length should be in between 8 to 30 characters, Minimum 1 character should be uppercase, Minimum 1 character should be number, Minimum 1 character should be special, No sequential 3 numbers like '123' or '234'."
                        element={<Icon name="badge-info" root="common" />}
                        position="right"
                        event="hover"
                        hoverable
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={10}>
                      <InputLabel label="Confirm Password" indicator="required" />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={10}>
                      <Input
                        fluid
                        error={null}
                        type="password"
                        maxLength="30"
                        placeholder="Confirm Password"
                        onChange={(data) => this.onNewPasswordConfirmChange(data)}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearSelectionAfterCancelEdit();
            }}
          />
          <Button
            type="primary"
            content="Submit"
            size="small"
            onClick={async () => {
              const isPwdMatching = this.isPasswordMatching(this.state.form);
              if (isPwdMatching === true) {
                this.toggleLoading();
                const response = await this.props.appContext.updatePassword(this.state.form);
                this.toggleLoading();
                if (!(response instanceof Error)) {
                  this.setState({ open: false });
                  this.props.appContext.setNotification(
                    `Please login with new password`,
                    'success',
                    true
                  );
                  this.props.appContext.logout();
                }
              } else {
                this.props.appContext.handleModalError('Passwords do not match.');
              }
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}
export default withRouter(
  withApplicationContext(
    withCustomerSiteContext(withUserContext(withOperatorContext(withDeviceInfoContext(Nav))))
  )
);
